/**
 * SmoothScroll Component
 *
 * Provides smooth scrolling for on-page anchor links.
 */
class SmoothScroll {
	/**
	 * Initializes the component by finding all anchor links and adding event listeners.
	 */
	init() {
		this.anchorLinks = document.querySelectorAll( 'a[href^="#"]' );

		if ( this.anchorLinks.length === 0 ) {
			return;
		}

		this.anchorLinks.forEach( ( link ) => {
			link.addEventListener( 'click', ( event ) => this._handleScroll( event ) );
		} );
	}

	/**
	 * Handles the click event on an anchor link.
	 * @param {Event} event - The click event object.
	 */
	_handleScroll( event ) {
		const href = event.currentTarget.getAttribute( 'href' );

		// Make sure it's not just a hash.
		if ( href.length <= 1 ) {
			return;
		}

		try {
			const targetElement = document.querySelector( href );
			if ( targetElement ) {
				event.preventDefault();
				targetElement.scrollIntoView( {
					behavior: 'smooth',
					block: 'start',
				} );
			}
		} catch ( e ) {
			// Catch invalid selector errors.
			console.error( 'SmoothScroll: Invalid selector.', e );
		}
	}
}

export default SmoothScroll;
